module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chatTray"
  }, [_c('a', {
    staticClass: "drop-down-menu",
    on: {
      "click": function($event) {
        _vm.toggleTray()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-wrapper"
  }, [_c('div', [(_vm.historyOpen) ? _c('chatContacts', {
    staticClass: "side-nav",
    attrs: {
      "user": _vm.user,
      "contacts": _vm.contacts,
      "person": _vm.person
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "chat-container",
    attrs: {
      "disabled": !this.person
    }
  }, [_c('div', {
    ref: "chat",
    staticClass: "chat"
  }, [(_vm.isEmpty) ? _c('div', {
    class: _vm.backgroundMessage
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('str.NoMessages')))])]) : _c('ul', {
    staticClass: "chatList",
    style: (_vm.messagesIEHackStyle),
    attrs: {
      "name": "messages"
    }
  }, [_vm._l((_vm.chatList), function(messageData, index) {
    return _c('chatbox', {
      key: index,
      attrs: {
        "messageData": messageData,
        "person": _vm.getPerson(messageData.from),
        "user": _vm.user
      },
      on: {
        "openPersonCard": function($event) {
          _vm.openPersonCard($event)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.messagesSending), function(messageData, index) {
    return _c('chatbox', {
      key: _vm.chatList.length + index,
      attrs: {
        "messageData": messageData,
        "person": _vm.user,
        "user": _vm.user
      },
      on: {
        "openPersonCard": function($event) {
          _vm.openPersonCard($event)
        }
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    class: _vm.chatSubmit
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatText),
      expression: "chatText"
    }],
    staticClass: "chat-text",
    attrs: {
      "placeholder": _vm.placeholder,
      "disabled": !this.person
    },
    domProps: {
      "value": (_vm.chatText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitText($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chatText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "submit-button",
    attrs: {
      "src": require("../../assets/icons/enter.svg")
    },
    on: {
      "click": _vm.submitText
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-arrow-small"
  })])]), _vm._v(" "), (this.viewPerson) ? _c('personcard', {
    attrs: {
      "attendee": this.viewPerson,
      "user": _vm.user
    },
    on: {
      "cardClosed": _vm.personCardClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-282f738d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/ChatTray.vue
// module id = 466
// module chunks = 0